<p-dialog [(visible)]="_isOpen"
          [modal]="true"
          [autoZIndex]="autoZIndex"
          [baseZIndex]="baseZIndex"
          [closable]="dismissible"
          (onShow)="onShow()"
          (onHide)="onDismiss()">
    <p-header>
        <div class="modal-header">
            <ng-content select="[modal-header]"></ng-content>
        </div>
    </p-header>
    <div class="modal-body">
        <app-loading-spinner *ngIf="isLoading" class="loading-animation"></app-loading-spinner>
        <ng-content select="[modal-body]"></ng-content>
    </div>
    <p-footer>
        <div class="modal-footer">
            <ng-content select="[modal-footer]"></ng-content>
        </div>
    </p-footer>
</p-dialog>
